<template>
  <div class="tabs-component pt-md-2" id="top">
    <div class="tabs-component-tabs row">
      <div
        v-for="(tab, i) in tabs"
        :key="i"
        class="col-md-12 qa__links"
        :id="tab.index"
      >
        <div
          class="qa__box qa__box--small"
          :class="{ first: i === 1, last: i === tabs.length - 1 }"
          v-show="tab.isVisible"
        >
          <router-link
            class="qa__link"
            :to="/pytania-i-odpowiedzi/ + tab.index + '#' + tab.index"
            :id="tab.index"
          >
            <div v-html="tab.header" class="qa__headline"></div>
            <div
              class="qa__arrow"
              :class="{ active: activeTabIndex === tab.index }"
            >
              <img src="@/assets/images/10/arrow_qa.svg" alt="strzałka" />
            </div>
          </router-link>
          <div v-if="activeTabIndex === tab.index">
            <img
              v-if="activeTabIndex == 'pakiet-pszczelego-bohatera'"
              src="@/assets/images/12/pakiet-2026.png"

              class="qa__img mb-3"
              alt="Pakiet Pszczelego Bohatera"
            />

            <div v-html="tab.content" class="qa__content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    tabs: [],
    activeTabIndex: 0,
    loaded: false,
  }),

  inject: ["content"],
  mounted() {
    this.getDataContent();
    this.activeTabIndex = this.$route.params.id;
  },
  computed: {
    getFullPath() {
      return this.$route.path;
    },
  },

  methods: {
    getDataContent() {
      this.tabs = this?.content?.data.faq.accordeon;
      this.loaded = true;
    },
    getPageRefresh() {
      this.activeTabIndex = this.$route.params.id;
    },
    scrollToTop(id) {
      const width = window.innerWidth;
      let elementPosition = document.getElementById(id).offsetTop;
      if (width > 768) {
        window.scroll({
          top: elementPosition,
          left: 0,
        });
      } else {
        window.scroll({
          top: elementPosition - 20,
          left: 0,
        });
      }
    },
  },
  watch: {
    getFullPath() {
      this.getPageRefresh();
    },
  },
};
</script>
